import React, { useEffect } from "react";
import { connect } from "react-redux";
import Location from "../Location";
import { DropoffLocationSelection } from "../DropoffLocationSelection";
import { RootState } from "../../reducers";
import { getDestination, getEnableListViewForDestinationLocations, getIsServiceTow, getPartnerCode } from "../../selector";
import { getLocationRouterView, getUseNewLocationSelectionUI, getUserIsPPU } from "./selectors";
import { changeDisplayToggleLocationViewHeader, changeUseNewLocationSelectionUI } from "./actions";
import { PEP } from "../../app-consts/appConstants";

// This component is a temporary solution for navigating the Dropoff Location flow
// Round 1. AMC -> PPU utilizing new list view and old map view + service details overlay STATUS: COMPLETE

type LocationRouterProps = {
  changeDisplayToggleLocationViewHeader: (displayHeader: boolean) => void;
  changeUseNewLocationSelectionUI: (useFlow: boolean) => void;
  history: any;
  isDestinationConfirmed: boolean;
  isListViewEnabled: boolean;
  isPep: boolean;
  isTowService: boolean;
  isUserPPU: boolean;
  location: any;
  match: any;
  staticContext?: any;
  useNewUI: boolean;
  view: "list" | "map";
};

/**
 * Determines which Location Selection flow to display
 * The only customers who will see new list view will be: PPU AMC member
 */
export const Component = ({
  changeDisplayToggleLocationViewHeader,
  changeUseNewLocationSelectionUI,
  isDestinationConfirmed,
  isListViewEnabled,
  isPep,
  isUserPPU,
  isTowService,
  useNewUI,
  view,
  ...props
}: LocationRouterProps) => {
  useEffect(() => {
    // user is PPU, service is tow, destination has not been confirmed, and the partner is not pep boys
    if (isListViewEnabled && isUserPPU && isTowService && !isDestinationConfirmed && !isPep) {
      // Show exisiting map view, with toggle to go between list & map
      if (view === "map") {
        changeUseNewLocationSelectionUI(false);
        changeDisplayToggleLocationViewHeader(true);
        // Show list view UI
      } else {
        changeUseNewLocationSelectionUI(true);
      }
      // Show map view without toggle for list & map
    } else {
      changeUseNewLocationSelectionUI(false);
      changeDisplayToggleLocationViewHeader(false);
    }
  }, [isUserPPU, view, isDestinationConfirmed]);
  return useNewUI ? <DropoffLocationSelection /> : <Location {...props} />;
};
const mapStateToProps = (state: RootState) =>
  ({
    isDestinationConfirmed: getDestination(state).hasBeenConfirmed,
    isListViewEnabled: getEnableListViewForDestinationLocations(state),
    isPep: getPartnerCode(state) === PEP,
    isTowService: getIsServiceTow(state),
    isUserPPU: getUserIsPPU(state),
    useNewUI: getUseNewLocationSelectionUI(state),
    view: getLocationRouterView(state),
  } as Pick<
    LocationRouterProps,
    | "isDestinationConfirmed"
    | "isListViewEnabled"
    | "isPep"
    | "isTowService"
    | "isUserPPU"
    | "useNewUI"
    | "view"
  >);
export const LocationRouter = connect(mapStateToProps, {
  changeUseNewLocationSelectionUI,
  changeDisplayToggleLocationViewHeader,
})(Component);